module.exports = __webpack_public_path__ + "static/image/service/baeminstore.ver2_0_2.jpg?81649bf6";